var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailPlusFilled = function SvgMailPlusFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.878 14.546.744 5.411A4.99 4.99 0 0 1 5 3h7.294a7.036 7.036 0 0 0 4.675 8.7l-2.847 2.848a3.007 3.007 0 0 1-4.244-.002m5.658 1.414a5.01 5.01 0 0 1-7.072 0L.046 7.542C.032 7.7 0 7.843 0 8v11a5.006 5.006 0 0 0 5 5h14a5.006 5.006 0 0 0 5-5V9.894a6.97 6.97 0 0 1-4.478 2.08zM15 6h3v3a1 1 0 0 0 2 0V6h3a1 1 0 1 0 0-2h-3V1a1 1 0 0 0-2 0v3h-3a1 1 0 1 0 0 2"
  })));
};
export default SvgMailPlusFilled;